import { render } from "./Fees.vue?vue&type=template&id=0983732c"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"

import "./Fees.vue?vue&type=style&index=0&id=0983732c&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__